<template>
  <div class="content-header" @mouseleave="openTab(false)">
    <!-- <ul class="menu-box">
      <li
        class="menu-item"
        v-for="(item, index) in tabList"
        :key="index"
        @mouseenter="openTab(true)"
        @mouseover="changeTab(item, index)"
      >{{item.productCateName}}</li>
    </ul>
    <div class="menu-content-container" v-if="tabContainer" @mouseleave="openTab(false)">
      <div @mouseenter="openTab(true)">
        <div class="block_10">
          <div class="color_2" />
          <span class="txt_8" :lines="1">二级分类</span>
        </div>
        <div class="second-types clearfix">
          <div
            class="second-type-item fl"
            @click="chooseLevel2(item)"
            v-for="item in tabList[tabActive].productCateInfoVos"
            :key="item.id"
          >{{item.productCateName}}</div>
        </div>
        <div class="block_14" v-if="recommendedCourses.length > 0">
          <div class="colorDiv_2" />
          <span class="txt_12" :lines="1">推荐课程</span>
        </div>
        <div
          class="buttonBgWraps clearfix"
          @click="goToRecommendCourses(item)"
          v-for="(item, index) in recommendedCourses"
          :key="index"
        >
      
          <img class="icon_3" src="../images/img_32389_0_430.png" />
          <div class="desc">{{item.name1}}</div>
        </div>
      </div>
    </div> -->
    <div class="layerWrap">
      <!-- swiper1 -->
      <swiper
        class="swiper gallery-top"
        :options="swiperOptionTop"
        ref="swiperTop"
        v-if="swiperImgList.length > 0"
      >
        <swiper-slide
          :class="'slide-'+index"
          v-for="(item,index) in swiperImgList.slice(0,6)"
          :key="index"
        >
          <a :href="item.url_jump"  target="_blank">
            <img
              :src="item.image"
              
            />
          </a>

          <!-- <img :src="item.image" @click="handleClickToHref(item.linkUrl)" /> -->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev prev1" slot="button-prev"></div>
        <div class="swiper-button-next next1" slot="button-next"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <!-- <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs" v-if="swiperImgList.length > 0">
                <swiper-slide :class="'slide-'+index" v-for="(item,index) in swiperImgList" :key="index">
                    <img :src="item.image"/>
                </swiper-slide>
      </swiper>-->
    </div>
  </div>
</template>

<script>
import {
  getHomeBannerList,
  getProductCateRecommendList,
  getProductListByCateId_1,
  getbannerList
} from "@/servers/api";

export default {
  name: "ImgSwiperBlock",
  data() {
    return {
      isCollapse: true,
      swiperOptionTop: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
        },
        observer: true, // 动态检查器,自动初始化swiper,默认为false
        observerParents: true, //将observe应用于Swiper的父元素.当Swiper的父元素变化时,Swiper更新.如window.resize.
        // Some Swiper option/callback...
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // paginationClickable: true,
        // loopedSlides: 5, // looped slides should be the same
        // spaceBetween: 10,
        // observer: true, // 动态检查器,自动初始化swiper,默认为false
        // observerParents: true //将observe应用于Swiper的父元素.当Swiper的父元素变化时,Swiper更新.如window.resize.
      },
      // swiperOptionThumbs: {
      //     loop: true,
      //     direction: 'vertical',
      //     slidesPerView: '4',
      //     centeredSlides: true,
      //     touchRatio: 0.2,
      //     slideToClickedSlide: true,
      //     navigation: {
      //         nextEl: '.prev1',
      //         prevEl: '.next1'
      //     }
      // },
      tabList: [],
      tabActive: 0,
      swiperImgList: [],
      tabContainer: false,
      recommendedCourses: []
    };
  },
  mounted() {
    this.getbannerList();
  },
  created() {
    // this.getProductCateRecommendList();
  },
  methods: {
    async getProductCateRecommendList() {
      const params = {
        currentPage: 1,
        pageSize: 7
      };
      const res = await getProductCateRecommendList(params);
      if (res.code == 0) {
        this.tabList = res.data.slice(0, 7);
        // this.tabActive = res[0].id
      }
    },
    async getProductListByCateId_1(id) {
      const params = {
        productCate_1: id
      };
      const res = await getProductListByCateId_1(params);
      if (res.code == 0) {
        this.recommendedCourses = res.data || [];
      }
    },
    getbannerList() {
      let params = {
        status: 1
      };
      getHomeBannerList(params).then(res => {
        this.swiperImgList = res.data;
        /// console.log(res.data);
        this.$nextTick(() => {
          const swiperTop = this.$refs.swiperTop.$swiper;
          // const swiperThumbs = this.$refs.swiperThumbs.$swiper
          // swiperTop.controller.control = swiperThumbs
          // swiperThumbs.controller.control = swiperTop
        });
      });
    },
    handleClickToHref(url) {
      if (url) window.open(url);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    // 切换nav
    changeTab(item, index) {
      this.tabActive = index;
      this.getProductListByCateId_1(item.id);
    },
    openTab(value) {
      this.tabContainer = value;
    },
    chooseLevel2(item) {
      // this.$router.push({
      //     path: '/specialCourse',
      //     query: {
      //         id: item.id,
      //         pid: item.pid
      //         }
      // });
      window.open("#/specialCourse?id=" + item.id + "&pid=" + item.pId);
    },
    goToRecommendCourses(item) {
      window.open("#/course/detail?id=" + item.id);
    }
  }
};
</script>

<style src="../index.css" scoped></style>

<style scoped lang="less">
.second-types {
  margin: 30px;
  .second-type-item {
    opacity: 1;
    margin-right: 10px;
    line-height: 20px;
    white-space: nowrap;
    color: #666666;
    font-size: 14px;
    font-weight: 400;
    padding-right: 15px;
    border-right: 1px solid #999;
    cursor: pointer;
    &:hover {
      color: #FFDB6A;
    }
  }
  .second-type-item:last-of-type {
    border: none;
  }
  .second-type-active {
    opacity: 1;
    margin-right: 10px;
    line-height: 20px;
    white-space: nowrap;
    color: #FFDB6A;
    font-size: 14px;
    font-weight: 400;
  }
}
/* swiper box */
.layerWrap {
  /*751*/
  width: 1200px;
  height: 440px;
  display: flex;
  overflow: hidden;
  padding-left: 10px;
  box-sizing: border-box;
  position: relative;
  .prev1 {
    position: absolute;
    // top: 40px;
    // left: 20px;
    // width: 39px;
    // height: 39px;
    // border-radius: 50%;
    background-color: rgba(1, 1, 1, 0.5);
    color: #fff;
    // transform:rotate(90deg);
    // -ms-transform:rotate(90deg); 	/* IE 9 */
    // -moz-transform:rotate(90deg); 	/* Firefox */
    // -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
    // -o-transform:rotate(90deg); 	/* Opera */
    cursor: pointer;
    z-index: 90;
    &:hover {
      background-color: rgba(6, 126, 242, 1);
    }
  }
  .next1 {
    // position: absolute;
    // top: 422px;
    // left: 888px;
    // width: 39px;
    // height: 39px;
    // border-radius: 50%;
    background-color: rgba(1, 1, 1, 0.5);
    color: #fff;
    // transform:rotate(90deg);
    // -ms-transform:rotate(90deg); 	/* IE 9 */
    // -moz-transform:rotate(90deg); 	/* Firefox */
    // -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
    // -o-transform:rotate(90deg); 	/* Opera */
    cursor: pointer;
    z-index: 90;
    &:hover {
      background-color: #fbc51d;
    }
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 26px;
    color: #fff;
  }
}

.layerWrap .gallery-top .swiper-slide img {
  width: 100%;
  height: 100%;
}
// .layerWrap .gallery-thumbs .swiper-slide img {
//     width: 100%;
//     height: 100%;
// }

/deep/ .el-submenu .el-submenu__title {
  height: 70px;
  line-height: 70px;
  font-size: 18px;
}

.el-menu--vertical {
  background-color: white !important;
}

.gallery-top {
  height: 100%;
  width: 100%;
  margin: 0;
}

// .gallery-thumbs {
//     width: 15%;
//     height: 100%;
//     box-sizing: border-box;

// }
/*
    .gallery-thumbs .swiper-slide {
        width: 25%;
        height: 100%;
        opacity: 0.4;
    }*/

// .gallery-thumbs .swiper-slide-active {
//     opacity: 1;
// }

.content-header {
  display: flex;
  position: relative;
  flex-direction: row;
  margin: 30px auto 0 auto;
  height: 440px;
  .menu-box {
    background: #FFDB6A;
    .menu-item {
      width: 200px;
      height: 63px;
      line-height: 63px;
      padding-left: 30px;
      background: #FFDB6A;
      cursor: pointer;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 1px;
      .all {
        float: left;
        width: 20px;
        margin-top: 20px;
      }
      .all-text {
        float: left;
        padding-left: 10px;
      }
    }
    .menu-item:hover {
      background: #0265c4;
    }
  }
}
.menu-content-container {
  position: absolute;

  z-index: 10;
  width: 653px;
  height: 436px;
  background: #ffffff;
  border: 2px solid rgba(6, 126, 242, 1);
  left: 230px;
}
.buttonBgWraps {
  display: inline-block;
  margin-top: 10px;
  margin-left: 24px;
  padding-left: 20px;
  cursor: pointer;
  height: 28px;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  border: 1px solid rgba(255, 133, 133, 1);
  // -moz-box-shadow:2px 2px 2px #FFC097;
  // -webkit-box-shadow:2px 2px 2px #FFC097;
  // box-shadow:2px 2px 2px #FFC097;
  &:hover {
    box-shadow: 0px 0px 2px 0px rgba(255, 0, 0, 0.5);
  }
}
.buttonBgWraps img {
  margin-top: 10px;
  margin-right: 10px;
  float: left;
  position: relative;
  width: 9px;
  height: 13px;
}
.buttonBgWraps .desc {
  padding-right: 40px;
}
</style>
